import $ from 'jquery';
import FJUtil from '../../../util/FJUtil';
import FJDomUtil from '../../../util/FJDomUtil';
import FJStringUtil from '../../../util/FJStringUtil';
import FJFontManager from '../../font/FJFontManager';

class FJBase {
    constructor(props) {
        props = props || {};
        this._name = 'FJBase';
        this._offset = typeof props.offset != 'undefined' ? props.offset : 10; // 阴影偏移距离，比例值
        this._angle = typeof props.angle != 'undefined' ? props.angle : 45; // 阴影偏移角度
        this._opacity = (props && props.opacity) || 100; // 阴影透明度
        this._color = (props && props.color) || null; // 文字颜色

        this._position = (props && props.position) || 'absolute';
    }

    toJSON() {
        return this.encode();
    }

    fromJSON(data) {
        this.decode(data);
        this._name = data.name;
    }

    encode() {
        return {
            name: this._name,
            offset: this._offset,
            angle: this._angle,
            color: this._color,
            opacity: this._opacity,
        };
    }
    decode(data) {
        this._offset = data.offset;
        this._angle = data.angle;
        this._color = data.color;
        this._opacity = data.opacity;
    }
    clone() {
        let object = new FJBase();
        object.decode(this);

        return object;
    }
    get name() {
        return this._name;
    }
    set offset(offset) {
        this._offset = offset;
    }
    get offset() {
        return this._offset;
    }

    set angle(angle) {
        this._angle = angle;
    }
    get angle() {
        return this._angle;
    }

    set color(color) {
        this._color = color;
    }
    get color() {
        return this._color;
    }

    set opacity(opacity) {
        this._opacity = opacity;
    }

    get opacity() {
        return this._opacity;
    }

    /**
     * 将style应用到
     * @param view
     * @param textData
     * @param {{}} options
     * @param {number} options.width  限制宽度
     */
    addToView(view, textData, options) {
        if (!view) return;

        // 如果不存在layer，则创建
        if (!this._layer) {
            this._layer = document.createElement('div');
            $(this._layer).addClass('fl-text-base');
            if (this._position === 'absolute') {
                $(this._layer).css({
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: '100%',
                    height: '100%',
                });
            } else {
                $(this._layer).css({
                    position: 'relative',
                });
            }
        }
        this._addTextToLayer(textData, this._layer, options);

        const {
            isAddToSupportLayer = false,
            supportLayer,
            supportAllAnimationLayer,
            isOnlyUpdateSupportLayer = false,
        } = options;

        if (isAddToSupportLayer && supportLayer) {
            supportAllAnimationLayer.appendChild(this._layer);
            if (!supportLayer.parentNode) {
                $(view).parent().before(supportLayer);
            }
        } else {
            if (isOnlyUpdateSupportLayer) {
                return;
            }
            view.appendChild(this._layer);
        }
    }

    /**
     * @desc 添加文字元素到layer
     * @param {Array} textData - 文字数据，是一个数组，以行进行拆分
     * @param layer
     * @param {{}} options
     * @param {string} options.combinationType - character | word
     */
    _addTextToLayer(textData, layer, options) {
        $(layer).html('');

        const { textStyle, isRichTextMode, isSubtitle = false, fontBaseCss, checkIsContainArabic } = options;
        let currentIndex = 0;
        let lastTextStyle = { ...textStyle[currentIndex] };

        const fontStyle = FJFontManager.fontStyleDisableData(fontBaseCss.fontFamily);

        // 每行最少保留一个空格， 防止没有字符导致的元素高度/宽度计算错误
        const prepareLineIfEmpty = value => {
            if (value.length === 0) {
                value.push(' ');
            } else if (value.length === 1 && value[0] === '') {
                value[0] = ' ';
            }
        };

        // 拆分为单词列表, 需要按单词换行
        const _stringSplitWord = (strValue, isUseNBSP = true) => {
            let wordList = strValue.split(' ');
            let words = [];
            let spaceWord = '';

            const blankSpace = isUseNBSP ? '&nbsp;' : ' ';

            wordList.forEach((w, i) => {
                if (i === wordList.length - 1) {
                    if (w !== '') {
                        if (spaceWord) words.push(spaceWord);
                        words.push(w);
                    } else {
                        if (spaceWord) words.push(spaceWord);
                    }
                } else if (w !== '') {
                    if (spaceWord) words.push(spaceWord);
                    words.push(w + blankSpace);
                    spaceWord = '';
                } else spaceWord += blankSpace;
            });
            return words;
        };

        textData.forEach(value => {
            value = value
                .replace(/\s/g, ' ')
                .replace(/[\b\f\n\r\t]/g, '')
                .replace(/\u0003/g, ' ')
                .replace(/\u001f/g, '')
                .replace(/[\u0000-\u0008]/g, '');

            if (options && options.combinationType === 'character') {
                // 按字符添加动画时需要给每个字符包裹span标签
                let emojis = this._findEmojis(value);

                let dataTextList = this.wrapTextByCSS(value, {
                    ...options,
                    textStyle: textStyle.slice(currentIndex, currentIndex + value.length),
                });

                prepareLineIfEmpty(dataTextList);

                dataTextList.forEach(item => {
                    let line = document.createElement('div');
                    const overflowLine = document.createElement('div');
                    $(overflowLine).addClass('fl-text-overflow');
                    $(line).addClass('fl-text-line').css({ 'vertical-align': 'bottom' });
                    layer.appendChild(overflowLine);
                    overflowLine.appendChild(line);

                    for (let i = 0; i < item.length; i++) {
                        const currentTextStyle = textStyle[currentIndex];
                        let singleWord = item.charAt(i);
                        if (singleWord === ' ') singleWord = ' ';
                        else if (emojis && emojis.length > 0) {
                            // 判断是否为表情字符
                            let emoji = emojis[0];
                            if (emoji.charAt(0) === singleWord) {
                                singleWord = emoji;
                                emojis.shift();
                                i += emoji.length - 1;
                            }
                        }
                        let span = document.createElement('span');
                        // 【FlexClip V5.2.2】【Safari】打开该工程，有一个文字的空格没了，进入实时输入后正常 singleWord === ' ' ? 'inline' : 'inline-block',
                        $(span).css({
                            display: singleWord === ' ' ? 'inline' : 'inline-block',
                            color: currentTextStyle?.fontColor,
                            fontWeight: currentTextStyle?.isBold && !fontStyle.disableBold ? 'bold' : 'normal',
                            fontStyle: currentTextStyle?.isItalic && !fontStyle.disableItalic ? 'italic' : 'normal',
                        });
                        $(span).addClass('fl-text-animation');
                        span.innerText = singleWord;
                        line.appendChild(span);
                        currentIndex++;
                    }
                });
            } else if (options && options.combinationType === 'word') {
                // 按单词添加动画时需要给每个字符包裹span标签
                let dataTextList = this.wrapTextByCSS(value, {
                    ...options,
                    textStyle: textStyle.slice(currentIndex, currentIndex + value.length),
                });

                prepareLineIfEmpty(dataTextList);

                dataTextList.forEach(item => {
                    // item = item.replace(/&nbsp;/g, ' ')
                    let oldWordList =
                        checkIsContainArabic || isSubtitle
                            ? FJStringUtil.stringSplitWordInSubtitle(item)
                            : _stringSplitWord(item, false);

                    const wordList = checkIsContainArabic
                        ? FJStringUtil.sortWordListByArabic([...oldWordList])
                        : [...oldWordList];

                    const line = document.createElement('div');
                    const overflowLine = document.createElement('div');
                    $(overflowLine).addClass('fl-text-overflow');
                    $(line).addClass('fl-text-line').css({ 'vertical-align': 'bottom' });
                    layer.appendChild(overflowLine);
                    overflowLine.appendChild(line);

                    wordList.forEach(word => {
                        let span = document.createElement('span');
                        if (isSubtitle && word.trim() === '') {
                            span.innerText = word;
                        } else {
                            $(span).css({ display: 'inline-block' });
                            $(span).addClass('fl-text-animation');

                            let tempText = '';
                            for (let i = 0; i < word.length; i++) {
                                const currentTextStyle = textStyle[currentIndex];
                                if (FJUtil.isTextStyleEqual(currentTextStyle, lastTextStyle)) {
                                    tempText = tempText + word[i];
                                } else {
                                    const spanText = document.createElement('span');
                                    if (isRichTextMode) {
                                        $(spanText).css({
                                            color: lastTextStyle?.fontColor,
                                            fontWeight:
                                                lastTextStyle?.isBold && !fontStyle.disableBold ? 'bold' : 'normal',
                                            fontStyle:
                                                lastTextStyle?.isItalic && !fontStyle.disableItalic
                                                    ? 'italic'
                                                    : 'normal',
                                        });
                                    }
                                    spanText.innerText = tempText;
                                    span.appendChild(spanText);
                                    tempText = word[i];
                                }

                                currentIndex++;
                                lastTextStyle = currentTextStyle;

                                if (i === word.length - 1 && tempText) {
                                    const spanText = document.createElement('span');
                                    if (isRichTextMode) {
                                        $(spanText).css({
                                            color: lastTextStyle?.fontColor,
                                            fontWeight:
                                                lastTextStyle?.isBold && !fontStyle.disableBold ? 'bold' : 'normal',
                                            fontStyle:
                                                lastTextStyle?.isItalic && !fontStyle.disableItalic
                                                    ? 'italic'
                                                    : 'normal',
                                        });
                                    }
                                    spanText.innerText = tempText;
                                    span.appendChild(spanText);
                                    tempText = '';
                                }
                            }
                        }

                        line.appendChild(span);
                    });
                });
            } else {
                if (isRichTextMode) {
                    const dataTextList = this.wrapTextByCSS(value, {
                        ...options,
                        textStyle: textStyle.slice(currentIndex, currentIndex + value.length),
                    });

                    prepareLineIfEmpty(dataTextList);

                    dataTextList.forEach(item => {
                        let span = document.createElement('span');
                        $(span).css({ display: 'inline-block' });
                        $(span).addClass('fl-text-animation');

                        let tempText = '';
                        for (let i = 0; i < item.length; i++) {
                            const currentTextStyle = textStyle[currentIndex];
                            if (FJUtil.isTextStyleEqual(currentTextStyle, lastTextStyle)) {
                                tempText = tempText + item[i];
                            } else {
                                const spanText = document.createElement('span');
                                $(spanText).css({
                                    color: lastTextStyle?.fontColor,
                                    fontWeight: lastTextStyle?.isBold && !fontStyle.disableBold ? 'bold' : 'normal',
                                    fontStyle:
                                        lastTextStyle?.isItalic && !fontStyle.disableItalic ? 'italic' : 'normal',
                                });
                                spanText.innerText = tempText;
                                span.appendChild(spanText);
                                tempText = item[i];
                            }

                            currentIndex++;
                            lastTextStyle = currentTextStyle;

                            if (i === item.length - 1 && tempText) {
                                const spanText = document.createElement('span');
                                $(spanText).css({
                                    color: lastTextStyle?.fontColor,
                                    fontWeight: lastTextStyle?.isBold && !fontStyle.disableBold ? 'bold' : 'normal',
                                    fontStyle:
                                        lastTextStyle?.isItalic && !fontStyle.disableItalic ? 'italic' : 'normal',
                                });
                                spanText.innerText = tempText;
                                span.appendChild(spanText);
                                tempText = '';
                            }
                        }

                        const line = document.createElement('div');
                        const overflowLine = document.createElement('div');
                        $(overflowLine).addClass('fl-text-overflow');
                        $(line).addClass('fl-text-line').css({ 'vertical-align': 'bottom' });
                        layer.appendChild(overflowLine);
                        overflowLine.appendChild(line);

                        line.appendChild(span);
                    });
                } else {
                    let dataTextList = this.wrapTextByCSS(value, options);

                    prepareLineIfEmpty(dataTextList);

                    dataTextList.forEach(item => {
                        let span = document.createElement('span');
                        $(span).css({ display: 'inline-block' });
                        span.innerText = item;

                        const line = document.createElement('div');
                        const overflowLine = document.createElement('div');
                        $(overflowLine).addClass('fl-text-overflow');
                        $(line).addClass('fl-text-line').css({ 'vertical-align': 'bottom' });
                        layer.appendChild(overflowLine);
                        overflowLine.appendChild(line);

                        line.appendChild(span);
                    });
                }
            }
        });
    }

    /**
     * @desc 按字符换行拆分字符串 返回按行拆分的字符列表
     * @param {string} word
     * @param {{}} options
     * @returns
     */
    _splitInChar = (word, options) => {
        const { isUseNBSP = true } = options;
        let _textDataList = [];
        if (word === '') return _textDataList;

        // 创建dom元素包裹一行的字符串计算是否超出每行的最大宽度
        let line = document.createElement('div');
        $(line).css({ 'vertical-align': 'bottom' });

        let span = document.createElement('span');
        $(span).css({ display: 'inline-block' });

        let wordsQueue = [word];

        while (wordsQueue.length > 0) {
            let curWord = wordsQueue[wordsQueue.length - 1];
            span.innerHTML = curWord.replace(/ /g, '&nbsp;');

            // options.maxWidth 不存在时表示不限定宽度，不需要判读是否换行
            if (options.maxWidth && this._checkTextLineFeed(line, span, options)) {
                // 需要将处理过的空格还原 用以计算换行位置
                curWord = curWord.replace(/&nbsp;/g, ' ');
                let { index, surplusWords } = this._getLineFeedIndex(curWord, options);

                let lineWord = curWord.slice(0, index).replace(/ /g, isUseNBSP ? '&nbsp;' : ' ');
                _textDataList.push(lineWord);
                wordsQueue.length -= 1;

                if (surplusWords !== '') {
                    // 将剩余字符串入队列
                    surplusWords = surplusWords.replace(/ /g, isUseNBSP ? '&nbsp;' : ' ');
                    wordsQueue.push(surplusWords);
                }
            } else {
                // 不需要换行的处理 递归出口， 只执行一次
                _textDataList.push(curWord);
                wordsQueue.length -= 1;
            }
        }

        return _textDataList;
    };

    /**
     * @description 按照css换行规则拆分字符串
     * @param textValue
     * @param options
     * @returns {*[]}
     */
    wrapTextByCSS = (textValue, options) => {
        // 按行拆分的字符串列表 css换行规则
        let textDataList = [];

        if (options.maxWidth) {
            textDataList = this.getTextDataByDom(textValue, options);
        } else {
            textDataList.push(textValue);
        }
        return textDataList;
    };

    /**
     * @description 按照字符换行规则拆分字符串
     * @param textValue
     * @param options
     * @returns {*[]|boolean}
     */
    getTextDataByDom(textValue, options) {
        const { elementBox: _element, addElement: _addElement } = FJDomUtil.getTextDataDom(textValue, options);
        const spanList = _addElement.querySelectorAll('span');
        let lastTop = null;
        const textDataList = [];
        let lineText = '';
        [...spanList].forEach(span => {
            const { top } = span.getBoundingClientRect();
            if (lastTop === null) {
                lastTop = top;
                lineText += span.innerText;
            } else {
                if (lastTop === top) {
                    lineText += span.innerText;
                } else {
                    lastTop = top;
                    textDataList.push(lineText);
                    lineText = span.innerText;
                }
            }
        });
        if (lineText) {
            textDataList.push(lineText);
        }
        _element.parentNode.removeChild(_element);
        return textDataList;
    }

    /**
     * @desc 按单词换行拆分字符串 返回按行拆分的字符列表
     * @param {[]} words  单词列表
     * @param {{}} options
     * @returns
     */
    _splitInWord = (words, options) => {
        // 按行拆分的字符串列表
        let textDataList = [];
        // 一行的字符串
        let textLineDate = '';

        let line = document.createElement('div');
        $(line).css({ 'vertical-align': 'bottom' });

        let span = document.createElement('span');
        $(span).css({ display: 'inline-block' });
        line.appendChild(span);

        // 将 words 从最后一个开始入队列
        let wordsQueue = [];
        for (let i = words.length - 1; i >= 0; i--) wordsQueue.push(words[i]);

        while (wordsQueue.length > 0) {
            let curWord = wordsQueue[wordsQueue.length - 1];
            span.innerHTML = textLineDate + curWord;

            if (options.maxWidth && this._checkTextLineFeed(line, span, options)) {
                if (textLineDate === '') {
                    let textDataChartList = this._splitInChar(curWord, options);

                    textDataList = [...textDataList, ...textDataChartList.slice(0, -1)];
                    // 已处理单词出队列
                    wordsQueue.length -= 1;

                    // 完整单词无法放下时取挤下来的最后一行字符串当成完整的单词 去判断后续的单词
                    textLineDate = textDataChartList[textDataChartList.length - 1];
                } else {
                    textDataList.push(textLineDate);
                    textLineDate = '';
                }
            } else {
                textLineDate += curWord;
                // 已处理单词出队列
                wordsQueue.length -= 1;
            }
        }

        if (textLineDate !== '') {
            textDataList.push(textLineDate);
        }

        return textDataList;
    };

    /**
     * @desc 获取文本的换行位置，及去除一行之后的剩余文本
     * @param {string} words 当前文本
     * @param {number} options.maxWidth 当前dom一行限制最大的宽度
     * @param {number} options.viewScale  缩放比例
     * @param {fontBaseCss} options.fontBaseCss 当前文本的css样式   用于计算添加当前文本的实际宽度
     * @param {{}} options.padding 当前文字对象的padding， 换行距离需要减去当前dom的padding
     * @returns {{number, string}} index: 换行的位置  surplusWords: 剩余字符串
     */
    _getLineFeedIndex(words, options) {
        const { maxWidth, viewScale, fontBaseCss, padding = { left: 0, right: 0 } } = options;

        // 新建dom元素用于计算当前文本添加到画布中的实际宽度
        let _span = document.createElement('span');
        $(_span).css({ display: 'inline-block' });
        _span.innerHTML = words.replace(/ /g, '&nbsp;');

        $(_span).css({
            paddingLeft: padding.left + 'px',
            paddingRight: padding.right + 'px',
        });

        $(_span).css({
            position: 'absolute',
            left: 'auto',
            top: 0,
            width: 'auto',
            height: 'auto',
            zIndex: 100,
            transform: `translate(-50%, -50%) scale(${viewScale}) translate(50%, 50%)`,
            ...fontBaseCss,
        });

        // _wordsWidth 当前文本添加到画布中的实际宽度
        let _wordsWidth = FJDomUtil.calcDOMSize(_span.cloneNode(true)).width;

        // 计算大概需要分多少行来显示当前输入的文本
        let _numWordLine = _wordsWidth / maxWidth;
        // 取每行平均字符数的较大值
        let _wordLineLength = Math.ceil(words.length / _numWordLine);

        // 判断当前这行的字符数是否满足最大宽度的限制， 不满足则缩减字符数直到满足为止
        let _words = words.slice(0, _wordLineLength);
        _span.innerHTML = _words.replace(/ /g, '&nbsp;');
        _wordsWidth = FJDomUtil.calcDOMSize(_span.cloneNode(true)).width;

        // _wordLineLength > 1 只剩下一个字符实在无法继续换行时不在减1
        for (let i = _wordLineLength; i >= 1; i--) {
            let _words = words.slice(0, i);
            _span.innerHTML = _words.replace(/ /g, '&nbsp;');
            _wordsWidth = FJDomUtil.calcDOMSize(_span.cloneNode(true)).width;

            if (_wordsWidth < maxWidth || i === 1) {
                _wordLineLength = i;
                break;
            }
        }

        // surplusWords 去除一行的文本后剩余的文本字符串
        // index 字符的换行位置
        return {
            index: _wordLineLength,
            surplusWords: words.slice(_wordLineLength),
        };
    }

    /**
     * @desc 判断字符串是否需要换行
     * @param {Element} elementBox 当前的 dom 面板
     * @param {Element} addElement  需要添加到面板中的 dom元素
     * @param {number} options.maxWidth 当前dom面板限制的最大的宽度
     * @param {number} options.viewScale  缩放比例
     * @param {{}} options.fontBaseCss 当前文本的css样式   用于计算添加当前文本的实际宽度
     * @param {{}} options.padding 当前文字对象的padding， 换行距离需要减去当前dom的padding
     */
    _checkTextLineFeed(elementBox, addElement, options) {
        const { maxWidth, viewScale, fontBaseCss, padding = { left: 0, right: 0 } } = options;
        if (maxWidth === -1) return false;

        let _element = elementBox.cloneNode();
        let _addElement = addElement.cloneNode(true);

        $(_element).css({
            paddingLeft: padding.left + 'px',
            paddingRight: padding.right + 'px',
        });

        _element.appendChild(_addElement);
        $(_element).css({
            position: 'absolute',
            left: 'auto',
            top: 0,
            // width: 'auto',
            height: 'auto',
            zIndex: 100,
            transform: `translate(-50%, -50%) scale(${viewScale}) translate(50%, 50%)`,
            ...fontBaseCss,
            width: maxWidth,
        });

        let _domWidth = FJDomUtil.calcDOMSize(_element.cloneNode(true)).width;

        return _domWidth - maxWidth > 5;
    }

    _findEmojis(str) {
        let emojiRE =
            /[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2700-\u27BF]|[\uD83C][\uDC00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDFFF\uFE0F]+|\uD83E[\uDD10-\uDDFF\uDE80-\uDEF3\uDF00-\uDFDF\uEA00-\uEA4F]/g;
        return str.match(emojiRE);
    }

    /**
     * @desc 获取所有文字元素
     * @return {null|*[textLayer, textLayer]}
     */
    getTextLayers() {
        let lineLayers = this.getLineLayers();
        if (!lineLayers || lineLayers.length === 0) return null;
        let textLayers = [];
        for (let i = 0; i < lineLayers.length; i++) {
            let line = lineLayers[i];
            let spans = $(line).find('span.fl-text-animation');
            const spansArray = Array.from(spans);
            textLayers = textLayers.concat(spansArray);

            // TODO 记录每个span所在的行，用于部分特殊的动画，可以考虑优化
            spansArray.forEach(span => {
                span.__TEXT_ANIMATION_LAYER__ = i;
            });
        }
        return textLayers;
    }

    getLineLayers() {
        return this._getLineLayersWithLayer(this._layer);
    }

    /**
     * @desc 获取layer下所有的行的元素层级
     * @param layer
     * @return {*|jQuery|null}
     */
    _getLineLayersWithLayer(layer) {
        if (!layer) return null;
        return $(layer).find('.fl-text-line');
    }

    /**
     * 更新文字的padding样式
     * @param padding
     */
    updatePadding(padding) {
        if (!this._layer) return;

        $(this._layer).css(padding);
    }

    /**
     * 更新文字某一行文字样式
     * @param styleData
     * @param lineIdx
     */
    updateStyle(styleData, lineIdx) {
        if (!this._layer) return;

        let lineLayers = this.getLineLayers();
        let fontSize = parseFloat(styleData.fontSize);
        let ref = (fontSize * this.offset) / 100;
        let x = ref * Math.cos((this.angle / 180) * Math.PI);
        let y = ref * Math.sin((this.angle / 180) * Math.PI);
        if (lineIdx < lineLayers.length) {
            let ele = lineLayers[lineIdx];
            if (this._color) {
                $(ele).css({
                    ...styleData,
                    color: this._color,
                    unicodeBidi: 'plaintext',
                });
            } else {
                $(ele).css(styleData);
            }
        }

        $(this._layer).css({
            transform: 'translate(' + x + 'px,' + y + 'px)',
            opacity: this._opacity,
        });
    }

    /**
     * @desc 更新所有行文字文字样式
     * @param styleData
     */
    updateAllLineStyle(styleData) {
        if (!this._layer) return;

        let lineLayers = this.getLineLayers();
        let fontSize = parseFloat(styleData.fontSize);
        let ref = (fontSize * this.offset) / 100;
        let x = ref * Math.cos((this.angle / 180) * Math.PI);
        let y = ref * Math.sin((this.angle / 180) * Math.PI);

        for (let i = 0; i < lineLayers.length; i++) {
            let line = lineLayers[i];
            if (this._color) {
                $(line).css({
                    ...styleData,
                    color: this._color,
                });

                FJDomUtil.updateSpanTextNodeColor(line, this._color);
            } else {
                $(line).css(styleData);
            }
        }

        $(this._layer).css({
            transform: 'translate(' + x + 'px,' + y + 'px)',
            opacity: this._opacity,
        });
    }

    isEqual(style) {
        let ret = true;

        ret &= this._offset === style.offset;
        ret &= this._angle === style.angle;
        ret &= this._color === style.color;

        return ret;
    }

    clear() {
        if (this._layer && this._layer.parentNode) {
            this._layer.parentNode.removeChild(this._layer);
        }
    }

    /**
     * @desc 获取实际的文字dom对象 <排除样式辅助>
     */
    getActualLayer() {
        if (!this._layer) return null;

        return this._layer;
    }
}

export default FJBase;
